export default "__VITE_ASSET__Dl8P7dMA__"